export default __webpack_public_path__ + "static/media/Ms. Suchismita.781c686a.png";